import { Ability } from '@casl/ability';
import { Actions, Subjects } from '../types';

const ability = new Ability<[Actions, Subjects]>();

export const canShowNotificationCenter = ability.can('show', 'notifications_center');

export default ability;
